import UnstakeConfirmationModal from './UnstakeConfirmationModal';

export default UnstakeConfirmationModal;
